import { Button, Checkbox, IconButton, Input, Link, Option, Select, Stack, Textarea, ToggleButtonGroup, Typography } from "@mui/joy";

//componentes
import Header from "../../../../components/Header";
import Sidebar from "../../../../components/Sidebar";
import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../../../services/api";
import { toast } from "react-toastify";
import realizaConsulta from "../../../../services/rm";

export default function GestaoDeProcesso() {

    const etapasRequisicao = [
        'Solicitante',
        'Aprov. Técnico',
        'Aprov. Gerencial',
        'Aprov. Institucional',
        'Análise Crítica Compras',
        'Compras',
        'Faturado',
        'Baixas',
        'Cancelado'
    ]

    const etapasCotacao = [
        'Comprador',
        'Aprov. mcp1',
        // 'Aprov. mcp2',
        'Aprov. mcpf',
        'Jurídico',
        'Aprov. gestor adm suprimentos',
        'Aprov. gestor contrato/equipamentos',
        'Aprov. diretoria operações',
        'Aprov. diretoria suporte operacional',
        'Aprov. diretoria equipamentos',
        'Aprov. diretoria geral',
        'Aprov. Diretor Final',
        'diligenciamento',
        'Aprov. gestor corporativo equipamentos',
        'Cancelado',
        'Finalizado'
    ]

    const decisoes = [
        'Aprovado',
        'Reprovado',
        'Cancelado',
        null
    ]

    const criterios = [
        {
            codigo: "ES",
            nome: "Estoque"
        },
        {
            codigo: "MP",
            nome: "Máquina parada"
        },
        {
            codigo: "NO",
            nome: "Normal"
        },
        {
            codigo: "UR",
            nome: "Urgente"
        },
    ]

    const mobile = useMediaQuery('(max-width:1200px)');
    const permissoes = JSON.parse(localStorage.getItem('usuario')).user.autenticacao;
    const loginUsuarioLogado = JSON.parse(localStorage.getItem('usuario')).user.login;

    // Usuários autorizados a alterar etapas 'Comprador' e 'diligenciamento'
    const usuariosEspeciais = ['marcos.vieira', 'lucas.fonseca', 'roger.vargas'];

    const [tipoRequisicao, setTipoRequisicao] = useState("requisicao");
    const [processo, setProcesso] = useState("");
    const [dadosRequisicao, setDadosRequisicao] = useState({ id: null, pms: "", movimento1101: "", movimento1102: "", movimento1103: "", movimento1104: "", movimento1121: "", movimento1108: "", etapaAtual: "", compradorId: null, processamento_os: null, numeroOs: null, tipoPedido: "", decisao: null, criterio: null, informacoesAdicionais: null });
    const [dadosCotacao, setDadosCotacao] = useState({ id: null, movimento1106: "", movimento1108: "", movimento1122: "", movimento1123: "", numeroOC: "", etapaAtual: "", comprador: "", decisao: null, informacoesAdicionais: null });
    const [compradores, setCompradores] = useState();
    const [tiposPedido, setTiposPedido] = useState();
    const [cotacoes, setCotacoes] = useState([]);
    const [arrayOC, setArrayOC] = useState([]);

    useEffect(() => {
        if (!permissoes.includes("gestao")) {
            window.location.href = "/centralTarefas"
            return;
        }
        else {
            obterCompradores();
            obterTiposDePedido();
        }
    }, []);

    useEffect(() => {
        if (tipoRequisicao == 'requisicao') {
            setProcesso("");
        }

        if (processo) {
            buscarProcesso();
        }
    }, [tipoRequisicao]);

    // const reset = () => {
    //     setDadosRequisicao({ id: null, pms: "", movimento1101: "", movimento1102: "", movimento1103: "", movimento1104: "", movimento1121: "", movimento1108: "", etapaAtual: "", compradorId: null, processamento_os: null, numeroOs: null, tipoPedido: "", decisao: null, criterio: null });
    //     setDadosCotacao({ id: null, movimento1106: "", movimento1108: "", movimento1122: "", movimento1123: "", numeroOC: "", etapaAtual: "", comprador: "", decisao: null });
    // }

    const obterCompradores = async () => {
        /* 
          Buscar lista de compradores do R.M
        */
        realizaConsulta('01.001.023', { params: {} })
            .then(function ({ data }) {

                let nomesCompradores = [];
                if (data.length > 0) {
                    for (let i = 0; i < data.length; i++) {
                        nomesCompradores.push(
                            {
                                nome: data[i].NOME,
                                codigo: data[i].CODVEN,
                                compradorId: data[i].COMPRADORID,
                            });//TODO: pegar comprador id
                    }
                }
                setCompradores(nomesCompradores);
            }).catch(function (err) {
                console.error("Não funcionou obterCompradores");
                toast.error(JSON.stringify(err.response.data));
            });
    }

    const obterTiposDePedido = async () => {
        try {
            const response = await api.get('/tiposPedido/');
            if (response.status === 200) {
                setTiposPedido(response.data);
            }
        } catch (error) {
            toast.error(JSON.stringify(error));
        }
    }

    const buscarProcesso = async () => {
        if (!processo) return;

        //Chamar a rota de consulta do processo
        try {
            const result = await api.get(`/gestaoDeProcesso/${processo}/${tipoRequisicao == "requisicao" ? "REQ" : "COT"}`)
            if (result.status === 200) {
                if (!result.data.solicitacao) {
                    toast.info("Requisição / Cotação não encontrada!");
                    return;
                }

                if (tipoRequisicao == "requisicao") {
                    setCotacoes(result.data.cotacoes);
                    setArrayOC(result.data?.arrayOC);
                    console.log("TESTE", result.data);
                    setDadosRequisicao({
                        id: result.data.solicitacao.id,
                        compradorId: result.data.solicitacao.compradorId ? result.data.solicitacao.compradorId.toString() : null,
                        etapaAtual: result.data.solicitacao.etapaAtual,
                        movimento1101: result.data.solicitacao.numeroMov1 || "",
                        movimento1102: result.data.solicitacao.numeroMov2 || "",
                        movimento1103: result.data.solicitacao.numeroMov3 || "",
                        movimento1104: result.data.solicitacao.numeroMov4 || "",
                        movimento1108: result.data.solicitacao.numeroMov8 || "",
                        movimento1121: result.data.solicitacao.numeroMov21 || "",
                        pms: result.data.solicitacao.numeroPms || "",
                        processamento_os: result.data.solicitacao.processamento_os,
                        numeroOs: result.data.solicitacao.numeroOs || "",
                        tipoPedido: result.data.solicitacao.tipoPedido,
                        decisao: result.data.solicitacao.decisao,
                        criterio: result.data.solicitacao.criterio
                    });
                }
                else {
                    setDadosCotacao({
                        id: result.data.solicitacao.id,
                        etapaAtual: result.data.solicitacao.etapaAtual,
                        movimento1106: result.data.solicitacao.numeroMov6 || "",
                        movimento1108: result.data.solicitacao.numeroMov8 || "",
                        movimento1122: result.data.solicitacao.numeroMov22 || "",
                        movimento1123: result.data.solicitacao.numeroMov23 || "",
                        numeroOC: result.data.solicitacao.numeroOC || "",
                        comprador: result.data.solicitacao.comprador,
                        decisao: result.data.solicitacao.decisao
                    });
                }
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const atualizarProcesso = async () => {
        if (!processo) return;

        //Chamar a rota que busca o processo
        const data = {
            tipo_processo: tipoRequisicao == "requisicao" ? "REQ" : "COT"
        }

        if (tipoRequisicao == 'requisicao') {

            //Verificando se etapa atual ou decisão é cancelado, se for ambas tem que ser cancelado
            if ((dadosRequisicao.etapaAtual == "Cancelado" && dadosRequisicao.decisao != "Cancelado") || (dadosRequisicao.etapaAtual != "Cancelado" && dadosRequisicao.decisao == "Cancelado")) {
                toast.warning("Para definir etapa atual ou decisão como cancelado, ambas precisam estar na opção cancelado!");
                return;
            }

            //Obtendo nome do comprador
            const compradorData = compradores.find(c => c.compradorId == dadosRequisicao.compradorId);
            if (compradorData) {
                data.comprador = compradorData.nome;
                data.compradorId = dadosRequisicao.compradorId;
            }

            data.id = dadosRequisicao.id;
            data.numeroPms = dadosRequisicao.pms;
            data.etapaAtual = dadosRequisicao.etapaAtual;
            data.status = dadosRequisicao.etapaAtual == "Cancelado" ? 2 : 1;
            data.numeroMov1 = dadosRequisicao.movimento1101;
            data.numeroMov2 = dadosRequisicao.movimento1102;
            data.numeroMov3 = dadosRequisicao.movimento1103;
            data.numeroMov4 = dadosRequisicao.movimento1104;
            data.numeroMov21 = dadosRequisicao.movimento1121;
            data.processamento_os = dadosRequisicao.processamento_os == 1 ? 1 : null;
            data.tipoPedido = dadosRequisicao.tipoPedido;
            data.decisao = dadosRequisicao.decisao;
            data.criterio = dadosRequisicao.criterio;
            data.informacoesAdicionais = dadosRequisicao.informacoesAdicionais;
        }
        else {
            //Verificando se etapa atual ou decisão é cancelado, se for ambas tem que ser cancelado
            if ((dadosCotacao.etapaAtual == "Cancelado" && dadosCotacao.decisao != "Cancelado") || (dadosCotacao.etapaAtual != "Cancelado" && dadosCotacao.decisao == "Cancelado")) {
                toast.warning("Para definir etapa atual ou decisão como cancelado, ambas precisam estar na opção cancelado!");
                return;
            }
            data.id = dadosCotacao.id;
            data.numeroMov6 = dadosCotacao.movimento1106;
            data.numeroMov8 = dadosCotacao.movimento1108;
            data.numeroMov22 = dadosCotacao.movimento1122;
            data.numeroMov23 = dadosCotacao.movimento1123;
            data.status = dadosCotacao.etapaAtual == "Cancelado" ? 2 : 1;
            data.etapaAtual = dadosCotacao.etapaAtual;
            data.numeroOC = dadosCotacao.numeroOC;
            data.decisao = dadosCotacao.decisao;
            data.comprador = dadosCotacao.comprador;
            data.informacoesAdicionais = dadosCotacao.informacoesAdicionais;
        }

        data.tipo_processo = tipoRequisicao == "requisicao" ? "REQ" : "COT";

        //Chamar a rota de update
        try {
            const response = await api.put(
                '/gestaoDeProcesso/' + (tipoRequisicao == "requisicao" ? dadosRequisicao.id : dadosCotacao.id),
                data
            );
            if (response.status === 200) {
                toast.success("Atualizado com sucesso");
            }
        } catch (error) {
            console.log(error);
            toast.error(JSON.stringify(error));
        }
    }

    return (
        <Stack backgroundColor="#F5F5F5" height="100vh">
            <Header mobile={mobile} />
            <Sidebar mobile={mobile} />

            <Stack ml={mobile ? "0px" : "280px"} mt="50px" overflow={"auto"} height={mobile ? "100%" : "calc(100vh - 200px)"} p={mobile ? "20px" : "50px"}>
                <Typography fontSize={16}>Gestão de Processo</Typography>
                <Stack flexDirection={mobile ? "column" : "row"} alignItems={mobile ? "flex-start" : "flex-end"}>
                    <Stack mt="20px" width={mobile ? "100%" : "fit-content"}>
                        <Typography>Qual tipo de processo?</Typography>
                        <ToggleButtonGroup
                            value={tipoRequisicao}
                            onChange={(event, newValue) => {
                                newValue && setTipoRequisicao(newValue)
                            }
                            }
                            sx={mobile ? { width: "100%" } : { width: "fit-content" }}
                        >
                            <IconButton value="requisicao" color="primary" sx={mobile ? { flex: 1 } : {}}>
                                <Typography sx={{ padding: "0 15px" }}>Requisição</Typography>
                            </IconButton>
                            <IconButton value="cotacao" color="primary" sx={mobile ? { flex: 1 } : {}}>
                                <Typography sx={{ padding: "0 15px" }}>Cotação</Typography>
                            </IconButton>
                        </ToggleButtonGroup>
                    </Stack>
                    <Stack mt={"20px"} ml={mobile ? "0px" : "20px"} width={mobile ? "100%" : "fit-content"}>
                        <Typography>{tipoRequisicao == "requisicao" ? "ID da Solicitação" : "Numero do movimento 1.1.06"}</Typography>
                        <Input value={processo} onChange={e => setProcesso(e.target.value)} type="number" />
                    </Stack>
                    <Button onClick={buscarProcesso} sx={{ marginTop: "20px", marginLeft: mobile ? "0px" : "50px", width: mobile ? "100%" : "auto" }}>Pesquisar</Button>
                    {tipoRequisicao == "requisicao" && dadosRequisicao.id && <Button sx={mobile ? {} : { marginLeft: "20px" }} variant="plain" onClick={() => window.open('/solicitacao/' + dadosRequisicao.id)}>Abrir requisição</Button>}
                    {tipoRequisicao == "cotacao" && dadosCotacao.id && <Button sx={mobile ? {} : { marginLeft: "20px" }} variant="plain" onClick={() => window.open('/aprovacaoCompras/' + dadosCotacao.movimento1106)}>Abrir cotação</Button>}
                </Stack>
                {((tipoRequisicao == "requisicao" && dadosRequisicao.pms) || (tipoRequisicao == "cotacao" && dadosCotacao.movimento1106)) && <Stack>
                    {tipoRequisicao == "requisicao" ?
                        <Stack width={mobile ? "100%" : "fit-content"} flexDirection={"row"} flexWrap={"wrap"} mt="40px" gap="20px">
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>ID Solicitação</Typography>
                                <Input value={dadosRequisicao.id} disabled />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>PMS</Typography>
                                <Input value={dadosRequisicao.pms} onChange={e => setDadosRequisicao(current => ({ ...current, pms: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.01</Typography>
                                <Input value={dadosRequisicao.movimento1101} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1101: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.02</Typography>
                                <Input value={dadosRequisicao.movimento1102} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1102: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.03</Typography>
                                <Input value={dadosRequisicao.movimento1103} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1103: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.04</Typography>
                                <Input value={dadosRequisicao.movimento1104} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1104: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.21</Typography>
                                <Input value={dadosRequisicao.movimento1121} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1121: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.08</Typography>
                                <Input value={dadosRequisicao.movimento1108} onChange={e => setDadosRequisicao(current => ({ ...current, movimento1108: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"} minWidth={mobile ? "auto" : "140px"}>
                                <Typography>Comprador</Typography>
                                <Select defaultValue="1" value={dadosRequisicao.compradorId} onChange={(event, newValue) => setDadosRequisicao(current => ({ ...current, compradorId: newValue }))} >
                                    {compradores.map((comprador, index) => {
                                        return (
                                            <Option key={index} value={comprador.compradorId}>{comprador.nome}</Option>
                                        );
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"}>
                                <Typography>Tipo do Pedido</Typography>
                                <Select value={dadosRequisicao.tipoPedido} onChange={(event, newValue) => setDadosRequisicao(current => ({ ...current, tipoPedido: newValue }))}>
                                    {tiposPedido.map((tipoPedido, index) => {
                                        return (
                                            <Option key={index} value={tipoPedido.tipoPedido}>{tipoPedido.descricao}</Option>
                                        )
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"}>
                                <Typography>Etapa atual</Typography>
                                <Select value={dadosRequisicao.etapaAtual} onChange={(event, newValue) => {
                                    if (dadosRequisicao.etapaAtual === "Aprov. Técnico" && !usuariosEspeciais.includes(loginUsuarioLogado)) {
                                        toast.warning("A etapa Aprov. Técnico não pode ser antecipada, pois ela gera movimentos necessários no RM");
                                        return;
                                    }
                                    if (dadosRequisicao.etapaAtual !== "Solicitante" && newValue === "Solicitante" && !usuariosEspeciais.includes(loginUsuarioLogado)) {
                                        toast.warning("Não é possível voltar para a etapa Solicitante, pois movimentos do RM já foram gerados.");
                                        return;
                                    }

                                    setDadosRequisicao(current => ({ ...current, etapaAtual: newValue, decisao: newValue == "Cancelado" ? "Cancelado" : dadosRequisicao.decisao }));
                                }}>
                                    {etapasRequisicao.map((etapa, index) => {
                                        return (
                                            <Option key={index} value={etapa}>{etapa}</Option>
                                        );
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"}>
                                <Typography>Decisão</Typography>
                                <Select value={dadosRequisicao.decisao} onChange={(event, newValue) => setDadosRequisicao(current => ({ ...current, decisao: newValue, etapaAtual: newValue == "Cancelado" ? "Cancelado" : dadosRequisicao.etapaAtual }))}>
                                    {decisoes.map((decisao, index) => {
                                        return (
                                            <Option key={index} value={decisao}>{decisao ? decisao : "Nenhuma"}</Option>
                                        )
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"} minWidth={"138px"}>
                                <Typography>Critério</Typography>
                                <Select value={dadosRequisicao.criterio} onChange={(event, newValue) => {
                                    if (newValue === "MP" && !usuariosEspeciais.includes(loginUsuarioLogado)) {
                                        toast.warning("Não é possível alterar o critério de uma solicitação existente para Máquina parada.");
                                        return;
                                    }

                                    setDadosRequisicao(current => ({ ...current, criterio: newValue }));
                                }}>
                                    {criterios.map((criterio, index) => {
                                        return (
                                            <Option
                                                key={index}
                                                value={criterio.codigo}
                                                disabled={criterio.codigo === "MP" && !usuariosEspeciais.includes(loginUsuarioLogado)}
                                            >
                                                {criterio.nome}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Stack>
                            {dadosRequisicao.numeroOs &&
                                <Stack width={mobile ? "100%" : "120px"} alignItems={mobile ? "flex-start" : "center"}>
                                    <Typography sx={{ marginBottom: "10px" }}>O.S Processada</Typography>
                                    <Checkbox checked={dadosRequisicao.processamento_os} onChange={e => setDadosRequisicao(current => ({ ...current, processamento_os: e.target.checked }))} />
                                </Stack>
                            }
                            <Stack width={"100%"} minWidth={"138px"}>
                                <Typography>Informações Adicionais</Typography>
                                <Textarea placeholder="Descreva os motivos da sua interferência" minRows={6} value={dadosRequisicao.informacoesAdicionais} onChange={e => setDadosRequisicao(current => ({ ...current, informacoesAdicionais: e.target.value }))} />
                            </Stack>

                        </Stack>
                        :
                        <Stack width={"fit-content"} flexDirection={"row"} flexWrap={"wrap"} mt="40px" gap="20px">
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>ID Solicitação</Typography>
                                <Input value={dadosRequisicao.id} disabled />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.06</Typography>
                                <Input value={dadosCotacao.movimento1106} onChange={e => setDadosCotacao(current => ({ ...current, movimento1106: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.08</Typography>
                                <Input value={dadosCotacao.movimento1108} onChange={e => setDadosCotacao(current => ({ ...current, movimento1108: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.22</Typography>
                                <Input value={dadosCotacao.movimento1122} onChange={e => setDadosCotacao(current => ({ ...current, movimento1122: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Movimento 1.1.23</Typography>
                                <Input value={dadosCotacao.movimento1123} onChange={e => setDadosCotacao(current => ({ ...current, movimento1123: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "140px"}>
                                <Typography>Numero da OC</Typography>
                                <Input value={dadosCotacao.numeroOC} onChange={e => setDadosCotacao(current => ({ ...current, numeroOC: e.target.value }))} />
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"}>
                                <Typography>Etapa atual</Typography>
                                <Select 
                                    defaultValue="1" 
                                    value={dadosCotacao.etapaAtual}
                                    disabled={!usuariosEspeciais.includes(loginUsuarioLogado) && (dadosCotacao.etapaAtual === 'Comprador' || dadosCotacao.etapaAtual === 'diligenciamento')}
                                    onChange={(event, newValue) => setDadosCotacao(current => ({ ...current, etapaAtual: newValue, decisao: newValue == "Cancelado" ? "Cancelado" : dadosCotacao.decisao }))}>
                                    {etapasCotacao.map((etapa, index) => {
                                        return (
                                            <Option 
                                                key={index} 
                                                value={etapa}
                                                disabled={!usuariosEspeciais.includes(loginUsuarioLogado) && (etapa === 'Comprador' || etapa === 'diligenciamento')}
                                            >
                                                {etapa}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"}>
                                <Typography>Decisão</Typography>
                                <Select value={dadosCotacao.decisao} onChange={(event, newValue) => setDadosCotacao(current => ({ ...current, decisao: newValue, etapaAtual: newValue == "Cancelado" ? "Cancelado" : dadosCotacao.etapaAtual }))}>
                                    {decisoes.map((decisao, index) => {
                                        return (
                                            <Option key={index} value={decisao}>{decisao ? decisao : "Nenhuma"}</Option>
                                        )
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={mobile ? "100%" : "auto"} minWidth={mobile ? "auto" : "140px"}>
                                <Typography>Comprador</Typography>
                                <Select defaultValue="1" value={dadosCotacao.comprador} onChange={(event, newValue) => setDadosCotacao(current => ({ ...current, comprador: newValue }))} >
                                    {compradores.map((comprador, index) => {
                                        return (
                                            <Option key={index} value={comprador.nome}>{comprador.nome}</Option>
                                        );
                                    })}
                                </Select>
                            </Stack>
                            <Stack width={"100%"} minWidth={"138px"}>
                                <Typography>Informações Adicionais</Typography>
                                <Textarea placeholder="Descreva os motivos da sua interferência" minRows={6} value={dadosCotacao.informacoesAdicionais} onChange={e => setDadosCotacao(current => ({ ...current, informacoesAdicionais: e.target.value }))} />
                            </Stack>
                        </Stack>
                    }
                </Stack>
                }
                <Button onClick={atualizarProcesso} disabled={(tipoRequisicao == "requisicao" && !dadosRequisicao.pms) || (tipoRequisicao == "cotacao" && !dadosCotacao.movimento1106)} sx={mobile ? { width: "fit-content", alignSelf: "flex-end", marginTop: "20px", width: "100%" } : { width: "fit-content", alignSelf: "flex-end", marginTop: "40px" }}>Salvar Alterações</Button>
                {tipoRequisicao == 'requisicao' &&
                    <Stack>
                        <Typography fontWeight={500}>Cotações desta requisição:</Typography>
                        <Stack>
                            {arrayOC.map((cotacao, index) => {
                                console.log(cotacao);
                                return (
                                    <Link onClick={() => [setTipoRequisicao('cotacao'), setProcesso(Object.keys(cotacao))]} key={index}> {Object.values(cotacao)} </Link>
                                )
                            })}
                        </Stack>
                    </Stack>
                }
            </Stack>
        </Stack>
    );
}